import * as actions from '../actions/AuthActions'

export default (state = actions.AUTH_INITIAL_STATE, action = { payload: {}, type: '' }) => {
  switch (action.type) {
    case actions.AUTH_ACTION: {
      return { ...state, action: action.payload, error: null }
    }

    case actions.AUTH_CHANGE_PASSWORD: {
      return { ...state }
    }
    case actions.AUTH_CHANGE_PASSWORD_CANCELED: {
      return { ...actions.AUTH_INITIAL_STATE }
    }
    case actions.AUTH_CHANGE_PASSWORD_ERROR: {
      return { ...state, ...action.payload }
    }
    case actions.AUTH_CHANGE_PASSWORD_FULFILLED: {
      return { ...actions.AUTH_INITIAL_STATE }
    }

    case actions.AUTH_FETCH: {
      return { ...state, loaded: false, loading: true }
    }
    case actions.AUTH_FETCH_CANCELED: {
      return { ...actions.AUTH_INITIAL_STATE }
    }
    case actions.AUTH_FETCH_ERROR: {
      return {
        ...state,
        error: action.payload,
        loaded: false,
        loading: false,
        usr: null,
      }
    }
    case actions.AUTH_FETCH_FULFILLED: {
      return {
        ...state,
        action: null,
        error: null,
        loaded: true,
        loading: false,
        usr: action.payload,
      }
    }

    case actions.AUTH_LOGIN_CANCELED: {
      return { ...actions.AUTH_INITIAL_STATE }
    }

    case actions.AUTH_LOGIN_CREDENTIALS: {
      return state
    }
    case actions.AUTH_LOGIN_CREDENTIALS_ERROR: {
      return { ...state, ...action.payload }
    }
    case actions.AUTH_LOGIN_CREDENTIALS_FULFILLED: {
      return { ...actions.AUTH_INITIAL_STATE }
    }
    case actions.AUTH_LOGOUT: {
      return state
    }

    case actions.AUTH_LOGOUT_FULFILLED: {
      return { ...actions.AUTH_INITIAL_STATE }
    }
    case actions.AUTH_REFRESH_TOKEN: {
      return state
    }
    case actions.AUTH_REFRESH_TOKEN_CANCELED: {
      return { ...actions.AUTH_INITIAL_STATE }
    }
    case actions.AUTH_REFRESH_TOKEN_ERROR: {
      return { ...state, ...action.payload }
    }

    case actions.AUTH_REFRESH_TOKEN_FULFILLED: {
      return { ...actions.AUTH_INITIAL_STATE }
    }
    case actions.AUTH_RESET_PASSWORD: {
      return state
    }
    case actions.AUTH_RESET_PASSWORD_CANCELED: {
      return { ...actions.AUTH_INITIAL_STATE }
    }
    case actions.AUTH_RESET_PASSWORD_ERROR: {
      return { ...state, ...action.payload }
    }

    case actions.AUTH_RESET_PASSWORD_FULFILLED: {
      return { ...actions.AUTH_INITIAL_STATE }
    }
    case actions.AUTH_SET_AVATAR: {
      return {
        ...state,
        action: null,
        error: null,
        loaded: true,
        loading: false,
        usr: {
          // @ts-expect-error TS2698: Spread types may only be created from object types.
          ...state.usr,
          avatar: action.payload,
        },
      }
    }

    default:
  }
  return state
}
